import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Grid, TextField, Button } from '@nextiva/next-ui-components';

import { addDomain } from 'api/domainApi';

import styles from '../VerifyDrawer/VerifyDrawer.scss';

const AddressEntry = ({ handleSuccess, readOnly, initialEmail }) => {
  const [email, setEmail] = useState(initialEmail);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === '') {
      setErrorMessage('Please enter a valid email address');

      return;
    }

    try {
      await addDomain(email);
      setErrorMessage(null);
      handleSuccess(email);
    } catch (f) {
      setErrorMessage(f.errors?.[0].detail);
    }
  };

  return (
    <Grid className={styles.container} container spacing={0}>
      <Grid className={styles.title} item xs={12}>
        Enter an email address
      </Grid>
      <Grid className={styles.instructions} item xs={12}>
        <p>
          Enter an email address from a domain that you use to communicate with
          customers. We’ll send you a verification email.
        </p>
      </Grid>
      <Grid className={styles.textField} item xs={12}>
        <form
          onSubmit={handleSubmit}
          data-testid="PlatformAdminUI-AddressEntry-Form"
        >
          <TextField
            id="address-entry-email-address"
            data-testid="email-address"
            type="email"
            label="email address"
            disabled={readOnly}
            fullWidth
            placeholder="email address"
            value={email}
            error={errorMessage !== null}
            helperText={errorMessage}
            onChange={(e) => {
              setErrorMessage(null);
              setEmail(e.target.value.toLowerCase());
            }}
          />
        </form>
      </Grid>
      <Grid className={styles.sendVerificationButton} item xs={5}>
        <Button
          id="sendDomainVerification"
          color="primary"
          variant={readOnly ? 'outlined' : 'contained'}
          fullWidth
          onClick={handleSubmit}
          data-testid="PlatformAdminUI-AddressEntry-Button"
        >
          {readOnly ? 'Resend verification code' : 'Send verification email'}
        </Button>
      </Grid>
    </Grid>
  );
};

AddressEntry.propTypes = {
  handleSuccess: PropTypes.func.isRequired,
  initialEmail: PropTypes.string,
  readOnly: PropTypes.bool,
};

AddressEntry.defaultProps = {
  initialEmail: '',
  readOnly: false,
};

export default AddressEntry;
